module.exports = __webpack_public_path__ + "static/media/5DPO13.0be00264.jpg";